import React from 'react'
import { Link } from 'react-router-dom'
import Navigation from '@/components/Navigation'
import Footer from '@/components/Footer'
import {BookOpen, Calendar, ArrowRight, AlertTriangle} from 'lucide-react'

export default function BlogPage() {
  const articles = [
    {
      id: 1,
      title: 'The Hidden Dangers of WHMCS Bridge Nulled & Cracked Plugins',
      excerpt: 'Learn why using nulled plugins can expose your hosting business to security breaches, data theft, and legal consequences.',
      date: 'January 15, 2024',
      readTime: '5 min read',
      category: 'Security',
      slug: 'dangers-of-nulled-plugins',
      featured: true
    }
  ]

  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Page Header */}
      <section className="bg-gradient-to-br from-blue-50 to-white py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <div className="flex justify-center mb-4">
            <BookOpen className="w-12 h-12 text-blue-600" />
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Resources & Insights
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Expert guidance on WHMCS security, plugin management, and best practices for hosting providers.
          </p>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 gap-8">
            {articles.map((article) => (
              <article
                key={article.id}
                className={`bg-white border-2 ${
                  article.featured ? 'border-red-400' : 'border-gray-200'
                } rounded-xl p-8 hover:shadow-xl transition-all duration-300`}
              >
                <div className="flex items-start space-x-4">
                  {article.featured && (
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center">
                        <AlertTriangle className="w-6 h-6 text-red-600" />
                      </div>
                    </div>
                  )}
                  
                  <div className="flex-grow">
                    <div className="flex items-center space-x-4 mb-3">
                      <span className="bg-red-100 text-red-700 text-xs font-semibold px-3 py-1 rounded-full">
                        {article.category}
                      </span>
                      <div className="flex items-center text-sm text-slate-500 space-x-2">
                        <Calendar className="w-4 h-4" />
                        <span>{article.date}</span>
                        <span>•</span>
                        <span>{article.readTime}</span>
                      </div>
                    </div>

                    <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-3">
                      {article.title}
                    </h2>
                    
                    <p className="text-slate-600 mb-6 text-lg">
                      {article.excerpt}
                    </p>

                    <Link
                      to={`/blog/${article.slug}`}
                      className="inline-flex items-center text-blue-600 font-semibold hover:text-blue-700 transition-colors"
                    >
                      Read Full Article
                      <ArrowRight className="ml-2 w-5 h-5" />
                    </Link>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-blue-600">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Protect Your Business with Licensed Plugins
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Don't risk your client data with unverified scripts. Choose security and reliability.
          </p>
          <Link
            to="/plugins"
            className="inline-flex items-center px-8 py-4 bg-white text-blue-600 font-semibold rounded-lg hover:bg-blue-50 transition-all hover:shadow-xl"
          >
            Browse Secure Plugins
            <ArrowRight className="ml-2 w-5 h-5" />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  )
}
